import cn from "classnames";

export const TextInput = ({ label, name, className, ...args }) => {
  const classNames = cn(
    "block w-full rounded-md border-0 p-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 bg-white dark:bg-gray-900 dark:text-white",
    className,
  );

  return (
    <div className="flex-1">
      {label && (
        <label
          htmlFor={name}
          className="mb-2 block text-sm font-medium leading-6 text-gray-900"
        >
          {label}
        </label>
      )}
      <input id={name} name={name} className={classNames} {...args} />
    </div>
  );
};
